import IntakeResults from "@/pages/home/intake"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/home/intake/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <IntakeResults />
}
